import jwt from '@/http/requests/auth/jwt'

export default {

  fetchStrategies ({ commit }, idCampaign) {

    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/strategy/list', { idCampaign: idCampaign })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStrategiesSmall ({ commit }, idCampaign) {

    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/strategy/listsmall', { idCampaign: idCampaign })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStrategy (context, idStrategy) {
    return new Promise((resolve, reject) => {
      const url = idStrategy ? `/api/admin/strategy/${idStrategy}` : "/api/admin/strategy/new"
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveStrategy (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/strategy/save', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  syncStrategies (context, idCampaign) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/campaign/${idCampaign}/syncstrategies`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, idStrategy) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/strategy/delete/${idStrategy}`)
        .then((response) => {
          commit('REMOVE_RECORD', idStrategy)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
